import SpaceY from '../../../components/SpaceY';
import {
  MAX_WIDTH_639PX,
  s3CloudFrontUrlEndpoint,
} from '../../../utils/common';
import useClientMediaQuery from '../../../utils/hook/useClientMediaQuery';

import MissionReactSlick from './MissionReactSlick';
import MissionDescriptionWrapper from './MissionSectionWrapper';

const MissionSecondSection = () => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });

  const SLIDER_IMAGES = Array.from(
    { length: 4 },
    (_, i) =>
      `${s3CloudFrontUrlEndpoint}/mission/slider/v2/${
        isMobile ? 'mo' : 'pc'
      }${i}.svg`,
  );

  return (
    <MissionDescriptionWrapper
      headerChildren={
        <>
          불필요한 낭비를 막습니다
          <br />
          농산물의 가치 기준을
          {isMobile ? <br /> : ' '}
          바꿉니다
        </>
      }
    >
      <div className="relative h-373px overflow-hidden rounded-10px sm:h-[501px]">
        <img
          src={`${s3CloudFrontUrlEndpoint}/mission/potato_mouse.png`}
          alt="배추 사진"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 z-10 flex justify-center">
          <p className="mt-24px text-center text-18px font-bold leading-[27px] text-white sm:mt-48px sm:text-22px sm:leading-[33px]">
            농산물의 품질은 외형이 아닌 신선함, 맛<br />
            그리고 건강한 생산 과정에 있다는 믿음으로
            <br />
            어글리어스가 탄생했습니다.
          </p>
        </div>
      </div>

      <SpaceY height={48} />
      <div className="flex flex-col gap-48px sm:grid sm:grid-cols-2 ">
        <p className="text-18px leading-[28.8px] text-brand-1">
          건강하게 자란 농산물들이 외형으로 폐기되는 일이 없도록 발로 뛰고
          알리며 제 가치를 찾습니다. 조금 작거나 크거나 거칠어도 같은 땅에서
          자란 농산물의 본질에 집중합니다.
          <br />
          <br />
          <span className="font-bold">
            못난이 농산물을 헐값에 사들이는 관행을 깨고, 합리적인 가격으로
            정산하여 건강한 생산과 남김없는 소비가 지속되도록 힘 씁니다.
          </span>
        </p>

        <MissionReactSlick id="mission-slider" sliderImages={SLIDER_IMAGES} />
      </div>
    </MissionDescriptionWrapper>
  );
};

export default MissionSecondSection;
